import React, { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Button, Image } from 'semantic-ui-react';
import { usePopups } from '../../hooks/usePopups';

const messages = defineMessages({
  close: {
    id: 'popup.close',
    defaultMessage: 'Tancar',
  },
  moreInfo: {
    id: 'popup.moreInfo',
    defaultMessage: 'Més informació',
  },
});

interface PopupProps {
  className?: string;
}

const Popup: React.FC<PopupProps> = ({ className }) => {
  const intl = useIntl();
  const token = useSelector((state: any) => state.userSession.token);
  const [isVisible, setIsVisible] = useState(false);
  const [hasClosed, setHasClosed] = useState(false);

  // Use the custom hook for popup management
  const { currentPopup, loading, loaded, error } = usePopups();

  // Show popup when it's loaded and available
  React.useEffect(() => {
    if (loaded && currentPopup && !isVisible && !hasClosed && token) {
      setIsVisible(true);
    }
  }, [loaded, currentPopup, isVisible, hasClosed, token]);

  const handleClose = () => {
    setIsVisible(false);
    setHasClosed(true);
  };

  // Enllaç "Més informació" ara és un anchor, no cal handler

  // Don't render if loading, not loaded, no popup, or not visible
  if (loading || !loaded || !currentPopup || !isVisible) {
    return null;
  }

  // Show error state if needed
  if (error) {
    console.error('Error loading popups:', error);
    return null;
  }

  return (
    <div className={`popup-overlay ${className || ''}`}>
      <div className="popup-content">
        {currentPopup.image && (
          <div className="popup-image">
            <Image
              src={currentPopup.image.download}
              alt={currentPopup.title}
              fluid
            />
          </div>
        )}

        <div className="popup-text">
          <h3>{currentPopup.title}</h3>
          {currentPopup.description && <p>{currentPopup.description}</p>}

          <div className="popup-actions">
            {currentPopup.link_url && (
              <a
                href={currentPopup.link_url}
                target="_blank"
                rel="noopener noreferrer"
                className="ui button popup-more-info-btn"
              >
                {currentPopup.link_text ||
                  intl.formatMessage(messages.moreInfo)}
              </a>
            )}

            <Button onClick={handleClose} className="popup-close-btn">
              {intl.formatMessage(messages.close)}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Popup;
